import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import ContentRenderer from '../Renderers/ContentRenderer';
import List from '../List/List';
import MoreFilters from '../MoreFilters/MoreFilters';
import Sidebar from './Sidebar';
import SidebarTab from '../SidebarTab/SidebarTab';
import Tree from '../Tree/Tree';

const ITEM_DATA = [
  {
    imageUrl: 'https://images.unsplash.com/photo-1485872304698-0537e003288d?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
    title: 'Short Title',
  }, {
    imageUrl: 'https://images.unsplash.com/photo-1485601284679-a2f86e6f7dea?dpr=1&auto=format&fit=crop&w=1500&h=1000&q=80&cs=tinysrgb&crop=',
    title: 'Statehood Movement Grows in Columbia - the follow up',
    description: 'VCC Team FTW',
  }, {
    imageUrl: 'https://images.unsplash.com/photo-1485809876425-9c96ea4132fe?dpr=1&auto=format&fit=crop&w=168&h=112&q=80&cs=tinysrgb&crop=',
    title: 'Bernie Sanders on Debbie Wasserman Schultz Resignation - she made the right decision for the future of the Democratic party',
    description: 'Vimond Media Solutions',
  }
];

function createItems(num) {
  const items = [];

  for (let i = 0; i < 1; i++) {
    const root = {
      id: `root-${i}`,
      title: `Root ${i + 1}`,
      description: `Root folder with ${num} items`,
      children: [],
    };

    for (let j = 0; j < num; j++) {
      const subItem = {
        id: `id-${j}`,
        title: `Folder ${j + 1}`,
        description: `Folder with ${num} items`,
        children: [],
      };

      for (let k = 0; k < num; k++) {
        subItem.children.push({
          id: `id-${j + j}`,
          title: `Folder ${j + 1}.${k + 1}`,
          description: 'Empty folder',
        });
      }
      root.children.push(subItem);
    }
    items.push(root);
  }
  return items;
}

const renderer = (item) => <ContentRenderer {...item} item={item} folder={item.smartList} tag={item.changed && 'Draft'}/>;

export default class SidebarExample extends Component {

  constructor(props) {
    super(props);

    const items = [];
    for (let i = 0; i < 25; i++) {
      items.push({
        ...ITEM_DATA[i % 3],
        id: i,
      });
    }
    this.state = {
      items,
      treeItems: createItems(50),
    };
  }

  onChange = e => this.setState(e.target.value);

  onChangeTab = e => this.setState({ selected: e.target.value });

  onExpandCollapse = e => {
    const item = e.target.value;

    item.expanded = !item.expanded;
    this.setState({
      treeItems: this.state.treeItems,
    });
  };

  render() {
    const { items, treeItems, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Sidebar.defaultProps} propTypes={Sidebar.propTypes}
          propValues={this.state}>
          <Tip>Try setting the class to <span className="string">narrow</span>.</Tip>
        </Properties>
        <Sidebar onChange={this.onChangeTab} onResize {...rest}>
          <SidebarTab iconName="search">
            <div className="filter-bar">
              <p>Custom filterbar can be placed here</p>
              <MoreFilters>
                <p>Advanced filtering options can be displayed here</p>
              </MoreFilters>
            </div>
            <List items={items} itemRenderer={renderer}/>
          </SidebarTab>
          <SidebarTab iconName="hierarchy">
            <Tree items={treeItems} onExpandCollapse={this.onExpandCollapse}/>
          </SidebarTab>
          <SidebarTab iconName="settings" showSearch={false} className="settings" >
            <h4>Settings</h4>
            <p>You can put any component in here, or use <code>SidebarTab</code> and get support for multiple tabs etc.</p>
          </SidebarTab>
        </Sidebar>
        <SourceCode querySelector=".sidebar-example .core-sidebar"/>
      </Example>
    );
  }

}
